import { Pane } from 'evergreen-ui';

const LayoutProvider = ({ children }) => {
  return (
    <Pane height="100vh" background="#1F2021">
      {children}
    </Pane>
  );
};

export default LayoutProvider;
